// Redespliegue forzado para restaurar versión estable
import { Route, Routes } from "react-router";
import ResponsiveAppBar from "./components/Nav";
import Home from "./components/Home";
import Cedears from "./components/Cedears";
import Acciones from "./components/Acciones";
import Screener from "./components/Screener";
import NewTabComponent from "./components/NewTabComponent";
import Ratios from "./components/Ratios";
import Portfolios from "./components/Portafolios";
import Prueba from "./components/Prueba";
import Footer from "./components/Footer";
import Analisis from "./components/Analisis";
import MiPortfolio from "./components/MiPortfolio";
import { ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
  breakpoints: {
    values: { xs: 300, sm: 600, md: 960, lg: 1280, xl: 1920, xxl: 2000 },
  },
});

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <ResponsiveAppBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="Cedears" element={<Cedears />} />
          <Route path="Screener" element={<Screener />} />
          <Route path="Acciones" element={<Acciones />} />
          <Route path="Ratios" element={<Ratios />} />
          <Route path="Portfolios" element={<Portfolios />} />
          <Route path="new-tab" element={<NewTabComponent />} />
          <Route path="Prueba" element={<Prueba />} />
          <Route path="Analisis" element={<Analisis />} />
          <Route path="MiPortfolio" element={<MiPortfolio />} />
        </Routes>
        <Footer />
      </ThemeProvider>
    </div>
  );
}

export default App;
